module.exports = __webpack_public_path__ + "img/Monte_Kope_104.a36291fb.jpg";